<template>
  <div class="pointer data-table-th-line" :class="referer=='newmessage' ? 'phrase-brand-member-select' : type=='client' ? 'data-table-list-client' : type=='member' ? 'data-table-list-member' : ''" v-if="activate >= 15 || activate == 11">
    <el-dropdown trigger="click" placement="bottom-start" v-if="type=='client'">
      <div>
        <div v-if="client_select.target_client_id == 'all'">
          <span v-if="referer=='newmessage'">全ての</span>ブランド
          <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left:5px" />
        </div>
        <div class="list-detail-side-member" v-else>
          <img :src="client_select.img_url" class="list-member-profile-sidemenu" v-if="client_select.img_url != null" />
          <div v-else class="list-member-noimg">{{ client_select.target_client_name | firstLetter }}</div>
          <span v-if="referer=='newmessage'" class="list-detail-side-member-name">{{client_select.target_client_name}}</span>
          <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left:5px" />
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="selectClient(all_client)" :class="client_select.target_client_id == 'all' ? 'assign' : ''">全てのブランド</el-dropdown-item>
        <el-dropdown-item
          style="font-size:12px;"
          v-for="clientAll in target_client"
          :key="clientAll.id"
          class="member"
          @click.native="selectClient(clientAll)"
          :class="client_select.target_client_id == clientAll.target_client_id ? 'assign' : ''"
        >
          <img :src="clientAll.img_url" class="list-member-profile dropdown" v-if="clientAll.img_url != null" />
          <div class="list-member-noimg dropdown" v-else>{{ clientAll.target_client_name | firstLetter }}</div>
          <div class="list-member-dropdown-namearea">
            <div>{{ clientAll.target_client_name }}</div>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dropdown trigger="click" placement="bottom-start" v-else-if="type=='member'">
      <div>
        <div v-if="member_select.person_id == 'all'">
          <span v-if="referer=='newmessage'">全ての</span>メンバー
          <font-awesome-icon icon="caret-down" style="margin-left:5px" />
        </div>
        <div class="list-detail-side-member" v-else>
          <img :src="member_select.img_url" class="list-member-profile-sidemenu" v-if="member_select.img_url != null" />
          <div v-else class="list-member-noimg">{{ member_select.person_name | firstLetter }}</div>
          <span v-if="referer=='newmessage'" class="list-detail-side-member-name">{{member_select.person_name}}</span>
          <font-awesome-icon icon="caret-down" style="margin-left:5px" />
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="selectMember(all_member)" :class="member_select.person_id == 'all' ? 'assign' : ''">全てのメンバー</el-dropdown-item>
        <el-dropdown-item
          style="font-size:12px;"
          v-for="member in member"
          :key="member.id"
          class="member"
          @click.native="selectMember(member)"
          :class="member_select.person_id == member.person_id ? 'assign' : ''"
        >
          <img :src="member.img_url" class="list-member-profile dropdown" v-if="member.img_url != null" />
          <div class="list-member-noimg dropdown" v-else>{{ member.person_name | firstLetter }}</div>
          <div class="list-member-dropdown-namearea">
            <div>{{ member.person_name }}</div>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "memberBrandSelect",
  props: ["type", "member", "target_client", "referer"],
  data() {
    return {
      all_member: {
        person_id: "all",
      },
      all_client: {
        target_client_id: "all",
      },
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
    client_select() {
      return this.$store.state.client_select;
    },
    member_select() {
      return this.$store.state.member_select;
    },
  },
  methods: {
    selectMember(member) {
      this.$emit("selectMember", member);
    },
    selectClient(client) {
      this.$emit("selectClient", client);
    },
  },
  filters: {
    firstLetter(val) {
      return val.slice(0, 1);
    },
  },
};
</script>

<style></style>
